// Centralised JSON-LD schema builders for ElevatED.
// Keeps schema markup co-located, easy to audit, and avoids
// duplicating large blobs across pages.

const SITE_URL = 'https://elevatededucation.ca';
const LOGO = 'https://customer-assets.emergentagent.com/job_elevated-apply/artifacts/myyz19wz_transparent%20logo.png';

export const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Elevated Education',
  alternateName: 'ElevatED',
  legalName: 'Elevated Education',
  url: SITE_URL,
  logo: LOGO,
  image: LOGO,
  description:
    'Elevated Education is a Canadian education consulting agency helping Canadian students apply to BC career colleges and obtain provincial student aid.',
  email: 'info@elevatededucation.ca',
  telephone: '+1-778-654-8004',
  areaServed: { '@type': 'Country', name: 'Canada' },
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CA',
    addressRegion: 'BC',
  },
  sameAs: [],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'Elevated Education',
  publisher: { '@id': `${SITE_URL}/#organization` },
  inLanguage: 'en-CA',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/programs?search={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const buildBreadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const buildFAQSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.question || f.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: f.answer || f.a,
    },
  })),
});

export const buildServiceSchema = ({ name, description, slug }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  url: `${SITE_URL}/services/${slug}`,
  provider: { '@id': `${SITE_URL}/#organization` },
  areaServed: { '@type': 'Country', name: 'Canada' },
});

export const buildArticleSchema = ({
  headline,
  description,
  image,
  datePublished,
  slug,
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline,
  description,
  image: [image],
  datePublished,
  dateModified: datePublished,
  mainEntityOfPage: `${SITE_URL}/blog/${slug}`,
  author: {
    '@type': 'Organization',
    name: 'Elevated Education',
  },
  publisher: { '@id': `${SITE_URL}/#organization` },
});

export const buildInstitutionSchema = ({ name, slug, location, description, image }) => ({
  '@context': 'https://schema.org',
  '@type': 'CollegeOrUniversity',
  name,
  description,
  image,
  url: `${SITE_URL}/institutions/${slug}`,
  address: {
    '@type': 'PostalAddress',
    addressLocality: location,
    addressCountry: 'CA',
  },
});
